import type { IWeatherData } from './types';
import type { Moment } from 'moment/moment';

export const DEFAULT_WEATHER_DATA = {
  day: null,
  location: '',
  current: {
    atmosphere: {
      humidity: 0,
      pressure: 0,
      visibility: 0,
    },
    wind: {
      chill: 0,
      direction: 0,
      speed: 0,
    },
    conditions: {
      conditionText: 'cloudy',
      temperature: 67,
      unit: '',
    },
  },
};

export const generateCalendarWeekDays = (leftDate: Moment, rightDate: Moment): IWeatherData[] => {
  return new Array(Math.ceil(rightDate.diff(leftDate, 'days')) + 1).fill('').map((_, index) => ({
    day: leftDate.clone().add(index, 'days'),
    current: DEFAULT_WEATHER_DATA.current,
    location: DEFAULT_WEATHER_DATA.location,
  }));
};

